const types = {
  text: function text(data) {
    return data.value;
  },
  password: function password(data) {
    return data.value;
  },
  checkbox: function checkbox(data) {
    return data.checked;
  },
  radio: function radio(data) {
    return data.value;
  },
};

export default function createInputCHangeHandler(callback) {
  return function (event, data) {
    const value = data.type ? types[data.type](data) : data.value;
    callback(value);
  };
}
